import { Box } from "@material-ui/core";
import { usePopup } from "hooks/usePopup";
import { useState } from "react";
import batchServiceV4 from "services/batchServiceV4";
import { convertToFloat } from "utils/inputMasks";

import { SelectionPage } from "./SelectionPage";
import { ProductInfo, ProductText, StyledDialog, Image } from "./styles";

export const SelectionPopup = ({
  openSelectionPopup,
  handleCloseSelectionPopup,
  detailBatchData,
  updatePendingQuantity
}) => {
  const { addPopup } = usePopup();
  const [loading, setLoading] = useState(false);

  const handleSubmitSelection = async formData => {
    try {
      setLoading(true);
      await batchServiceV4.postSelection(detailBatchData.batchId, {
        goodQuantity: convertToFloat(formData.goodQuantity),
        diverseQuantity: convertToFloat(formData.diverseQuantity),
        wasteQuantity: convertToFloat(formData.wasteQuantity),
        wrongWeightQuantity: convertToFloat(formData.wrongWeightQuantity)
      });
      addPopup({
        type: "success",
        title: "Seleção realizada com sucesso"
      });

      const pendingQuantity = [
        convertToFloat(formData.goodQuantity),
        convertToFloat(formData.diverseQuantity),
        convertToFloat(formData.wasteQuantity),
        convertToFloat(formData.wrongWeightQuantity)
      ].reduce((acc, value) => acc - value, detailBatchData.pendingQuantity);

      updatePendingQuantity(detailBatchData.batchId, pendingQuantity);
      handleCloseSelectionPopup();
    } catch (error) {
      const errorMessage = error?.response?.data?.msg;
      addPopup({
        type: "error",
        title: "Erro ao realizar seleção",
        description: errorMessage
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <StyledDialog
      open={openSelectionPopup}
      handleClose={handleCloseSelectionPopup}
      title="Seleção"
    >
      <ProductInfo>
        <Box>
          <ProductText>
            Lote: <strong>{detailBatchData.batchId}</strong>
          </ProductText>
          <ProductText>
            Produto: <strong>{detailBatchData.productName}</strong>
          </ProductText>
          <ProductText>
            Seller: <span>{detailBatchData.sellerName}</span>
          </ProductText>
          <ProductText>
            Pendente: <span>{detailBatchData.pendingQuantity}</span>
          </ProductText>
        </Box>
        <Image src={detailBatchData.product?.image} />
      </ProductInfo>
      <SelectionPage
        batchData={detailBatchData}
        handleSubmit={handleSubmitSelection}
        close={handleCloseSelectionPopup}
        isLoading={loading}
      />
    </StyledDialog>
  );
};
